import img_0 from '../../assets/aws-svc-anim/images/img_0.png';
import img_1 from '../../assets/aws-svc-anim/images/img_1.png';
import img_2 from '../../assets/aws-svc-anim/images/img_2.png';
import img_3 from '../../assets/aws-svc-anim/images/img_3.png';
import img_4 from '../../assets/aws-svc-anim/images/img_4.png';
import img_5 from '../../assets/aws-svc-anim/images/img_5.png';
import img_6 from '../../assets/aws-svc-anim/images/img_6.png';
import img_7 from '../../assets/aws-svc-anim/images/img_7.png';
import img_8 from '../../assets/aws-svc-anim/images/img_8.png';
import img_9 from '../../assets/aws-svc-anim/images/img_9.png';
import img_10 from '../../assets/aws-svc-anim/images/img_10.png';
import img_11 from '../../assets/aws-svc-anim/images/img_11.png';
import img_12 from '../../assets/aws-svc-anim/images/img_12.png';
import img_13 from '../../assets/aws-svc-anim/images/img_13.png';
import img_14 from '../../assets/aws-svc-anim/images/img_14.png';
import img_15 from '../../assets/aws-svc-anim/images/img_15.png';
import img_16 from '../../assets/aws-svc-anim/images/img_16.png';
import img_17 from '../../assets/aws-svc-anim/images/img_17.png';
import img_18 from '../../assets/aws-svc-anim/images/img_18.png';
import img_19 from '../../assets/aws-svc-anim/images/img_19.png';
import img_20 from '../../assets/aws-svc-anim/images/img_20.png';
import img_21 from '../../assets/aws-svc-anim/images/img_21.png';
import img_22 from '../../assets/aws-svc-anim/images/img_22.png';
import img_23 from '../../assets/aws-svc-anim/images/img_23.png';
import img_24 from '../../assets/aws-svc-anim/images/img_24.png';
import img_25 from '../../assets/aws-svc-anim/images/img_25.png';
import img_26 from '../../assets/aws-svc-anim/images/img_26.png';
import img_27 from '../../assets/aws-svc-anim/images/img_27.png';
import img_28 from '../../assets/aws-svc-anim/images/img_28.png';
import img_29 from '../../assets/aws-svc-anim/images/img_29.png';
import img_30 from '../../assets/aws-svc-anim/images/img_30.png';
import img_31 from '../../assets/aws-svc-anim/images/img_31.png';
import img_32 from '../../assets/aws-svc-anim/images/img_32.png';
import img_33 from '../../assets/aws-svc-anim/images/img_33.png';

export default {
    "v": "5.9.0",
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 450.000018328876,
    "w": 2560,
    "h": 2880,
    "nm": "Final 1 File",
    "ddd": 0,
    "assets": [
        {
            "id": "image_0",
            "w": 849,
            "h": 212,
            "u": "",
            "p": img_0,
            "e": 0
        },
        {
            "id": "image_1",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_1,
            "e": 0
        },
        {
            "id": "image_2",
            "w": 156,
            "h": 156,
            "u": "",
            "p": img_2,
            "e": 0
        },
        {
            "id": "image_3",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_3,
            "e": 0
        },
        {
            "id": "image_4",
            "w": 156,
            "h": 156,
            "u": "",
            "p": img_4,
            "e": 0
        },
        {
            "id": "image_5",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_5,
            "e": 0
        },
        {
            "id": "image_6",
            "w": 156,
            "h": 156,
            "u": "",
            "p": img_6,
            "e": 0
        },
        {
            "id": "image_7",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_7,
            "e": 0
        },
        {
            "id": "image_8",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_8,
            "e": 0
        },
        {
            "id": "image_9",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_9,
            "e": 0
        },
        {
            "id": "image_10",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_10,
            "e": 0
        },
        {
            "id": "image_11",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_11,
            "e": 0
        },
        {
            "id": "image_12",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_12,
            "e": 0
        },
        {
            "id": "image_13",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_13,
            "e": 0
        },
        {
            "id": "image_14",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_14,
            "e": 0
        },
        {
            "id": "image_15",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_15,
            "e": 0
        },
        {
            "id": "image_16",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_16,
            "e": 0
        },
        {
            "id": "image_17",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_17,
            "e": 0
        },
        {
            "id": "image_18",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_18,
            "e": 0
        },
        {
            "id": "image_19",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_19,
            "e": 0
        },
        {
            "id": "image_20",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_20,
            "e": 0
        },
        {
            "id": "image_21",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_21,
            "e": 0
        },
        {
            "id": "image_22",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_22,
            "e": 0
        },
        {
            "id": "image_23",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_23,
            "e": 0
        },
        {
            "id": "image_24",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_24,
            "e": 0
        },
        {
            "id": "image_25",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_25,
            "e": 0
        },
        {
            "id": "image_26",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_26,
            "e": 0
        },
        {
            "id": "image_27",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_27,
            "e": 0
        },
        {
            "id": "image_28",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_28,
            "e": 0
        },
        {
            "id": "image_29",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_29,
            "e": 0
        },
        {
            "id": "image_30",
            "w": 174,
            "h": 174,
            "u": "",
            "p": img_30,
            "e": 0
        },
        {
            "id": "image_31",
            "w": 160,
            "h": 68,
            "u": "",
            "p": img_31,
            "e": 0
        },
        {
            "id": "image_32",
            "w": 615,
            "h": 906,
            "u": "",
            "p": img_32,
            "e": 0
        },
        {
            "id": "image_33",
            "w": 596,
            "h": 886,
            "u": "",
            "p": img_33,
            "e": 0
        },
        {
            "id": "comp_0",
            "nm": "Animation 2",
            "fr": 29.9700012207031,
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 5,
                    "nm": "AWS Services",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 22,
                                    "s": [
                                        0
                                    ]
                                },
                                {
                                    "t": 55.0000022401959,
                                    "s": [
                                        100
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                330.672,
                                2123.132,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                227.893,
                                -26.66,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                111.712,
                                111.712,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "t": {
                        "d": {
                            "k": [
                                {
                                    "s": {
                                        "s": 75,
                                        "f": "Roboto-Bold",
                                        "t": "AWS Services",
                                        "ca": 0,
                                        "j": 0,
                                        "tr": 0,
                                        "lh": 90,
                                        "ls": 0,
                                        "fc": [
                                            1,
                                            1,
                                            1
                                        ]
                                    },
                                    "t": 0
                                }
                            ]
                        },
                        "p": {},
                        "m": {
                            "g": 1,
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            }
                        },
                        "a": []
                    },
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 2,
                    "nm": "W17",
                    "refId": "image_1",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.233,
                                1988.767,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 2,
                    "nm": "B17",
                    "refId": "image_2",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.317,
                                1988.682,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                77.683,
                                77.682,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 4,
                    "ty": 2,
                    "nm": "W16",
                    "refId": "image_3",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.233,
                                1988.767,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 5,
                    "ty": 2,
                    "nm": "B16",
                    "refId": "image_4",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.317,
                                1988.682,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                77.683,
                                77.682,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 6,
                    "ty": 2,
                    "nm": "W15",
                    "refId": "image_5",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.233,
                                1988.767,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 7,
                    "ty": 2,
                    "nm": "B15",
                    "refId": "image_6",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.317,
                                1988.682,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                77.683,
                                77.682,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 8,
                    "ty": 2,
                    "nm": "W14",
                    "refId": "image_7",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.233,
                                1988.767,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 9,
                    "ty": 2,
                    "nm": "B14",
                    "refId": "image_8",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                -96.233,
                                1988.767,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 14,
                    "ty": 2,
                    "nm": "W11",
                    "refId": "image_9",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 247,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 251.00001022344,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 129,
                                    "s": [
                                        -96.233,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 241,
                                    "s": [
                                        2163.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 242,
                                    "s": [
                                        2163.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 259.000010549286,
                                    "s": [
                                        2330.267,
                                        1156.267,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 15,
                    "ty": 2,
                    "nm": "B11",
                    "refId": "image_10",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 129,
                                    "s": [
                                        -96.233,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 241,
                                    "s": [
                                        2163.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 242,
                                    "s": [
                                        2163.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 259.000010549286,
                                    "s": [
                                        2330.267,
                                        1156.267,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 16,
                    "ty": 2,
                    "nm": "W10",
                    "refId": "image_11",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 237,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 242.000009856862,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 117,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 231,
                                    "s": [
                                        2169.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 235,
                                    "s": [
                                        2169.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 250.000010182709,
                                    "s": [
                                        2023.892,
                                        1142.892,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 17,
                    "ty": 2,
                    "nm": "B10",
                    "refId": "image_12",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 117,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 231,
                                    "s": [
                                        2169.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 235,
                                    "s": [
                                        2169.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 250.000010182709,
                                    "s": [
                                        2023.892,
                                        1142.892,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 18,
                    "ty": 2,
                    "nm": "W9",
                    "refId": "image_13",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 223,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 224.000009123707,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 104,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 221,
                                    "s": [
                                        2170.016,
                                        1991.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 235.000009571746,
                                    "s": [
                                        2174.75,
                                        1082.517,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 19,
                    "ty": 2,
                    "nm": "B9",
                    "refId": "image_14",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 104,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 221,
                                    "s": [
                                        2170.016,
                                        1991.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 235.000009571746,
                                    "s": [
                                        2174.75,
                                        1082.517,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 20,
                    "ty": 2,
                    "nm": "W8",
                    "refId": "image_15",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 216,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 217.000008838591,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 91,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 209,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 214,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 223.000009082976,
                                    "s": [
                                        2256.766,
                                        1456.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2,
                            "x": "var $bm_rt;\n$bm_rt = loopOut();"
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 21,
                    "ty": 2,
                    "nm": "B8",
                    "refId": "image_16",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 91,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 209,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 214,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 223.000009082976,
                                    "s": [
                                        2256.766,
                                        1456.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 22,
                    "ty": 2,
                    "nm": "W7",
                    "refId": "image_17",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 209,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 211.000008594206,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 78,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 197,
                                    "s": [
                                        2168.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 200,
                                    "s": [
                                        2168.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 209,
                                    "s": [
                                        2126.195,
                                        1635.481,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 214.000008716399,
                                    "s": [
                                        2064.767,
                                        1452.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 23,
                    "ty": 2,
                    "nm": "B7",
                    "refId": "image_18",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 78,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 197,
                                    "s": [
                                        2168.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 200,
                                    "s": [
                                        2168.767,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 209,
                                    "s": [
                                        2126.195,
                                        1635.481,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 214.000008716399,
                                    "s": [
                                        2064.767,
                                        1452.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 24,
                    "ty": 2,
                    "nm": "W6",
                    "refId": "image_19",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 194,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 197.000008023974,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 65,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 186,
                                    "s": [
                                        2168.766,
                                        2003.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 189,
                                    "s": [
                                        2168.766,
                                        2003.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 194,
                                    "s": [
                                        2223.518,
                                        1612.763,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 203.000008268359,
                                    "s": [
                                        2371.767,
                                        1327.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 25,
                    "ty": 2,
                    "nm": "B6",
                    "refId": "image_20",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 65,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 186,
                                    "s": [
                                        2168.766,
                                        2003.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 189,
                                    "s": [
                                        2168.766,
                                        2003.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 194,
                                    "s": [
                                        2223.518,
                                        1612.763,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 203.000008268359,
                                    "s": [
                                        2371.767,
                                        1327.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 26,
                    "ty": 2,
                    "nm": "W5",
                    "refId": "image_21",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 184,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 186.000007575935,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 52,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 174,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 177,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 183,
                                    "s": [
                                        2123.567,
                                        1619.567,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 193.000007861051,
                                    "s": [
                                        1972.766,
                                        1302.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 27,
                    "ty": 2,
                    "nm": "B5",
                    "refId": "image_22",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 52,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 174,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 177,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 183,
                                    "s": [
                                        2123.567,
                                        1619.567,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 193.000007861051,
                                    "s": [
                                        1972.766,
                                        1302.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 28,
                    "ty": 2,
                    "nm": "W4",
                    "refId": "image_23",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 173,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 176.000007168627,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 40,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 142,
                                    "s": [
                                        1809.029,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 160,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 164,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 182.000007413012,
                                    "s": [
                                        2168.767,
                                        1279.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 29,
                    "ty": 2,
                    "nm": "B4",
                    "refId": "image_24",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 40,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 142,
                                    "s": [
                                        1809.029,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 160,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 164,
                                    "s": [
                                        2168.766,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 182.000007413012,
                                    "s": [
                                        2168.767,
                                        1279.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 30,
                    "ty": 2,
                    "nm": "W3",
                    "refId": "image_25",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 159,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 161,
                                    "s": [
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 238,
                                    "s": [
                                        0
                                    ]
                                },
                                {
                                    "t": 250.000010182709,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 26,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 149,
                                    "s": [
                                        2170.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 152,
                                    "s": [
                                        2170.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 168.00000684278,
                                    "s": [
                                        2329.767,
                                        1156.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 31,
                    "ty": 2,
                    "nm": "B3",
                    "refId": "image_26",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 238,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 250.000010182709,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 26,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 149,
                                    "s": [
                                        2170.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 152,
                                    "s": [
                                        2170.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 168.00000684278,
                                    "s": [
                                        2329.767,
                                        1156.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 32,
                    "ty": 2,
                    "nm": "W2",
                    "refId": "image_27",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 151,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 158,
                                    "s": [
                                        0
                                    ]
                                },
                                {
                                    "t": 252.00001026417,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 13,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 135,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 141,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 168.00000684278,
                                    "s": [
                                        2024.016,
                                        1142.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 33,
                    "ty": 2,
                    "nm": "B2",
                    "refId": "image_28",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 231,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 244.000009938324,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 13,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 135,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 141,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 168.00000684278,
                                    "s": [
                                        2024.016,
                                        1142.767,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 34,
                    "ty": 2,
                    "nm": "W1",
                    "refId": "image_29",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 140,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 148,
                                    "s": [
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 210,
                                    "s": [
                                        0
                                    ]
                                },
                                {
                                    "t": 224.000009123707,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 0,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 120,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 124,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 165.000006720588,
                                    "s": [
                                        2175.016,
                                        1079.267,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 270.000010997325,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 35,
                    "ty": 2,
                    "nm": "B1",
                    "refId": "image_30",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 210,
                                    "s": [
                                        100
                                    ]
                                },
                                {
                                    "t": 224.000009123707,
                                    "s": [
                                        0
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 0,
                                    "s": [
                                        -95.984,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 120,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "i": {
                                        "x": 0.833,
                                        "y": 0.833
                                    },
                                    "o": {
                                        "x": 0.167,
                                        "y": 0.167
                                    },
                                    "t": 124,
                                    "s": [
                                        2180.016,
                                        1988.767,
                                        0
                                    ],
                                    "to": [
                                        0,
                                        0,
                                        0
                                    ],
                                    "ti": [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    "t": 165.000006720588,
                                    "s": [
                                        2175.016,
                                        1079.267,
                                        0
                                    ]
                                }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                86.767,
                                86.767,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 272.000011078787,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 36,
                    "ty": 0,
                    "nm": "Path",
                    "refId": "comp_1",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                907.669,
                                2123.59,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                1279.912,
                                33.952,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                146.992,
                                146.992,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "w": 2560,
                    "h": 68,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 38,
                    "ty": 2,
                    "nm": "Bulb Wire",
                    "refId": "image_32",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                2173.64,
                                1436.779,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                306.571,
                                452.89,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 0,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 39,
                    "ty": 2,
                    "nm": "Bulb with fill 2",
                    "refId": "image_33",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 1,
                            "k": [
                                {
                                    "i": {
                                        "x": [
                                            0.833
                                        ],
                                        "y": [
                                            0.833
                                        ]
                                    },
                                    "o": {
                                        "x": [
                                            0.167
                                        ],
                                        "y": [
                                            0.167
                                        ]
                                    },
                                    "t": 136,
                                    "s": [
                                        0
                                    ]
                                },
                                {
                                    "t": 152.000006191087,
                                    "s": [
                                        100
                                    ]
                                }
                            ],
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                2173.583,
                                1436.678,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                297.708,
                                442.542,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 136.000005539394,
                    "op": 300.00001221925,
                    "st": 0,
                    "bm": 0
                }
            ]
        },
        {
            "id": "comp_1",
            "nm": "Path Comp 1",
            "fr": 29.9700012207031,
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                2169.625,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 65.0000026475043,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                2029.625,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 60.0000024438501,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1890.625,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 55.0000022401959,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 4,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1752.125,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 50.0000020365418,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 5,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1612.625,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 45.0000018328876,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 6,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1472.625,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 40.0000016292334,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 7,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1332.625,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 35.0000014255792,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 8,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1193.625,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 30.0000012219251,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 9,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 35,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                1055.125,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 25.0000010182709,
                    "op": 307.000012504366,
                    "st": -15.0000006109625,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 10,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 35,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                935.125,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 20.0000008146167,
                    "op": 317.000012911675,
                    "st": -5.00000020365417,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 11,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 35,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                815.125,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 15.0000006109625,
                    "op": 317.000012911675,
                    "st": -5.00000020365417,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 12,
                    "ty": 2,
                    "nm": "Path/Animation 2.ai",
                    "cl": "ai",
                    "refId": "image_31",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 35,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                695.125,
                                34,
                                0
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                80,
                                34,
                                0
                            ],
                            "ix": 1,
                            "l": 2
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6,
                            "l": 2
                        }
                    },
                    "ao": 0,
                    "ip": 10.0000004073083,
                    "op": 317.000012911675,
                    "st": -5.00000020365417,
                    "bm": 0
                }
            ]
        }
    ],
    "fonts": {
        "list": [
            {
                "fName": "Roboto-Bold",
                "fFamily": "Roboto",
                "fStyle": "Bold",
                "ascent": 75
            }
        ]
    },
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 2,
            "nm": "Logo.ai",
            "cl": "ai",
            "refId": "image_0",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 35,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        876,
                        1512,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        424.5,
                        106,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        160.377,
                        160.377,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "ip": 0,
            "op": 453.000018451068,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 0,
            "nm": "Animation 2",
            "refId": "comp_0",
            "sr": 1.5,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1400,
                        1700,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        1405,
                        1440,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "w": 2810,
            "h": 2880,
            "ip": 0,
            "op": 450.000018328876,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Shape Layer 4",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        1280,
                        1440,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": {
                                "a": 0,
                                "k": [
                                    2560,
                                    2880
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "nm": "Rectangle Path 1",
                            "mn": "ADBE Vector Shape - Rect",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.065467064053,
                                    0.068664618099,
                                    0.129411645029,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Rectangle 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 453.000018451068,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": [],
    "chars": [
        {
            "ch": "A",
            "size": 75,
            "style": "Bold",
            "w": 67.29,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                51.416,
                                                0
                                            ],
                                            [
                                                66.992,
                                                0
                                            ],
                                            [
                                                40.381,
                                                -71.094
                                            ],
                                            [
                                                26.807,
                                                -71.094
                                            ],
                                            [
                                                0.342,
                                                0
                                            ],
                                            [
                                                15.918,
                                                0
                                            ],
                                            [
                                                20.801,
                                                -14.648
                                            ],
                                            [
                                                46.484,
                                                -14.648
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "A",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                33.594,
                                                -53.125
                                            ],
                                            [
                                                42.529,
                                                -26.514
                                            ],
                                            [
                                                24.756,
                                                -26.514
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "A",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "A",
                        "np": 5,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": "W",
            "size": 75,
            "style": "Bold",
            "w": 87.45,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                50.049,
                                                -71.094
                                            ],
                                            [
                                                37.646,
                                                -71.094
                                            ],
                                            [
                                                25.928,
                                                -20.605
                                            ],
                                            [
                                                16.309,
                                                -71.094
                                            ],
                                            [
                                                1.709,
                                                -71.094
                                            ],
                                            [
                                                17.48,
                                                0
                                            ],
                                            [
                                                32.227,
                                                0
                                            ],
                                            [
                                                43.799,
                                                -47.559
                                            ],
                                            [
                                                55.371,
                                                0
                                            ],
                                            [
                                                70.117,
                                                0
                                            ],
                                            [
                                                85.889,
                                                -71.094
                                            ],
                                            [
                                                71.289,
                                                -71.094
                                            ],
                                            [
                                                61.719,
                                                -20.508
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "W",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "W",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": "S",
            "size": 75,
            "style": "Bold",
            "w": 61.47,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                1.953,
                                                -1.416
                                            ],
                                            [
                                                3.483,
                                                0
                                            ],
                                            [
                                                0,
                                                7.845
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -2.361,
                                                -3.483
                                            ],
                                            [
                                                -4.492,
                                                -2.002
                                            ],
                                            [
                                                -5.469,
                                                0
                                            ],
                                            [
                                                -4.655,
                                                3.5
                                            ],
                                            [
                                                0,
                                                6.152
                                            ],
                                            [
                                                3.809,
                                                3.711
                                            ],
                                            [
                                                8.333,
                                                2.507
                                            ],
                                            [
                                                2.327,
                                                1.562
                                            ],
                                            [
                                                0,
                                                2.312
                                            ],
                                            [
                                                -1.986,
                                                1.514
                                            ],
                                            [
                                                -3.581,
                                                0
                                            ],
                                            [
                                                -2.051,
                                                -1.807
                                            ],
                                            [
                                                0,
                                                -3.255
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                2.197,
                                                3.353
                                            ],
                                            [
                                                3.971,
                                                1.839
                                            ],
                                            [
                                                5.078,
                                                0
                                            ],
                                            [
                                                4.053,
                                                -1.692
                                            ],
                                            [
                                                2.164,
                                                -3.011
                                            ],
                                            [
                                                0,
                                                -3.841
                                            ],
                                            [
                                                -8.073,
                                                -4.362
                                            ],
                                            [
                                                -5.078,
                                                -1.643
                                            ],
                                            [
                                                -1.953,
                                                -1.481
                                            ],
                                            [
                                                0,
                                                -2.766
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.953,
                                                1.416
                                            ],
                                            [
                                                -9.375,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                4.59
                                            ],
                                            [
                                                2.36,
                                                3.484
                                            ],
                                            [
                                                4.492,
                                                2.002
                                            ],
                                            [
                                                7.877,
                                                0
                                            ],
                                            [
                                                4.655,
                                                -3.499
                                            ],
                                            [
                                                0,
                                                -5.534
                                            ],
                                            [
                                                -3.809,
                                                -3.711
                                            ],
                                            [
                                                -4.525,
                                                -1.367
                                            ],
                                            [
                                                -2.328,
                                                -1.562
                                            ],
                                            [
                                                0,
                                                -2.473
                                            ],
                                            [
                                                1.985,
                                                -1.514
                                            ],
                                            [
                                                3.711,
                                                0
                                            ],
                                            [
                                                2.051,
                                                1.807
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -4.264
                                            ],
                                            [
                                                -2.197,
                                                -3.352
                                            ],
                                            [
                                                -3.972,
                                                -1.839
                                            ],
                                            [
                                                -5.046,
                                                0
                                            ],
                                            [
                                                -4.053,
                                                1.693
                                            ],
                                            [
                                                -2.165,
                                                3.011
                                            ],
                                            [
                                                0,
                                                7.39
                                            ],
                                            [
                                                2.962,
                                                1.595
                                            ],
                                            [
                                                5.078,
                                                1.644
                                            ],
                                            [
                                                1.953,
                                                1.482
                                            ],
                                            [
                                                0,
                                                2.539
                                            ]
                                        ],
                                        "v": [
                                            [
                                                40.283,
                                                -12.72
                                            ],
                                            [
                                                32.129,
                                                -10.596
                                            ],
                                            [
                                                18.066,
                                                -22.363
                                            ],
                                            [
                                                3.369,
                                                -22.363
                                            ],
                                            [
                                                6.909,
                                                -10.254
                                            ],
                                            [
                                                17.188,
                                                -2.026
                                            ],
                                            [
                                                32.129,
                                                0.977
                                            ],
                                            [
                                                50.928,
                                                -4.272
                                            ],
                                            [
                                                57.91,
                                                -18.75
                                            ],
                                            [
                                                52.197,
                                                -32.617
                                            ],
                                            [
                                                33.984,
                                                -41.943
                                            ],
                                            [
                                                23.706,
                                                -46.338
                                            ],
                                            [
                                                20.215,
                                                -52.148
                                            ],
                                            [
                                                23.193,
                                                -58.13
                                            ],
                                            [
                                                31.543,
                                                -60.4
                                            ],
                                            [
                                                40.186,
                                                -57.69
                                            ],
                                            [
                                                43.262,
                                                -50.098
                                            ],
                                            [
                                                57.91,
                                                -50.098
                                            ],
                                            [
                                                54.614,
                                                -61.523
                                            ],
                                            [
                                                45.361,
                                                -69.312
                                            ],
                                            [
                                                31.787,
                                                -72.07
                                            ],
                                            [
                                                18.14,
                                                -69.531
                                            ],
                                            [
                                                8.813,
                                                -62.476
                                            ],
                                            [
                                                5.566,
                                                -52.197
                                            ],
                                            [
                                                17.676,
                                                -34.57
                                            ],
                                            [
                                                29.736,
                                                -29.712
                                            ],
                                            [
                                                40.283,
                                                -25.024
                                            ],
                                            [
                                                43.213,
                                                -18.652
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "S",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "S",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": " ",
            "size": 75,
            "style": "Bold",
            "w": 24.9,
            "data": {},
            "fFamily": "Roboto"
        },
        {
            "ch": "e",
            "size": 75,
            "style": "Bold",
            "w": 54.05,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                -3.613,
                                                1.676
                                            ],
                                            [
                                                -2.116,
                                                2.995
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                5.436,
                                                0
                                            ],
                                            [
                                                2.295,
                                                2.084
                                            ],
                                            [
                                                0.455,
                                                3.451
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.15,
                                                4.558
                                            ],
                                            [
                                                7.227,
                                                0
                                            ],
                                            [
                                                3.76,
                                                -2.262
                                            ],
                                            [
                                                2.051,
                                                -4.182
                                            ],
                                            [
                                                0,
                                                -5.305
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.867,
                                                -4.752
                                            ],
                                            [
                                                -7.748,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                3.613,
                                                -1.676
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -3.06,
                                                3.939
                                            ],
                                            [
                                                -3.516,
                                                0
                                            ],
                                            [
                                                -2.295,
                                                -2.083
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -8.366
                                            ],
                                            [
                                                -4.15,
                                                -4.557
                                            ],
                                            [
                                                -4.818,
                                                0
                                            ],
                                            [
                                                -3.76,
                                                2.263
                                            ],
                                            [
                                                -2.051,
                                                4.183
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                7.91
                                            ],
                                            [
                                                4.866,
                                                4.753
                                            ],
                                            [
                                                4.395,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                41.748,
                                                -1.538
                                            ],
                                            [
                                                50.342,
                                                -8.545
                                            ],
                                            [
                                                43.408,
                                                -16.309
                                            ],
                                            [
                                                30.664,
                                                -10.4
                                            ],
                                            [
                                                21.948,
                                                -13.525
                                            ],
                                            [
                                                17.822,
                                                -21.826
                                            ],
                                            [
                                                51.465,
                                                -21.826
                                            ],
                                            [
                                                51.465,
                                                -27.588
                                            ],
                                            [
                                                45.239,
                                                -46.973
                                            ],
                                            [
                                                28.174,
                                                -53.809
                                            ],
                                            [
                                                15.308,
                                                -50.415
                                            ],
                                            [
                                                6.592,
                                                -40.747
                                            ],
                                            [
                                                3.516,
                                                -26.514
                                            ],
                                            [
                                                3.516,
                                                -25.146
                                            ],
                                            [
                                                10.815,
                                                -6.152
                                            ],
                                            [
                                                29.736,
                                                0.977
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "e",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                -1.628,
                                                -1.717
                                            ],
                                            [
                                                -0.066,
                                                -3.139
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.742,
                                                1.897
                                            ],
                                            [
                                                -2.8,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                1.627,
                                                1.717
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0.488,
                                                -3.531
                                            ],
                                            [
                                                1.741,
                                                -1.897
                                            ],
                                            [
                                                2.995,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                35.059,
                                                -39.857
                                            ],
                                            [
                                                37.598,
                                                -32.574
                                            ],
                                            [
                                                37.598,
                                                -31.445
                                            ],
                                            [
                                                17.969,
                                                -31.445
                                            ],
                                            [
                                                21.313,
                                                -39.587
                                            ],
                                            [
                                                28.125,
                                                -42.432
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "e",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "e",
                        "np": 5,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": "r",
            "size": 75,
            "style": "Bold",
            "w": 36.47,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.562,
                                                0
                                            ],
                                            [
                                                2.832,
                                                -4.85
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -5.339,
                                                0
                                            ],
                                            [
                                                -1.921,
                                                -0.26
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.367,
                                                -0.423
                                            ],
                                            [
                                                -5.013,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.66,
                                                -3.613
                                            ],
                                            [
                                                1.465,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                35.303,
                                                -53.174
                                            ],
                                            [
                                                30.908,
                                                -53.809
                                            ],
                                            [
                                                19.141,
                                                -46.533
                                            ],
                                            [
                                                18.75,
                                                -52.832
                                            ],
                                            [
                                                5.42,
                                                -52.832
                                            ],
                                            [
                                                5.42,
                                                0
                                            ],
                                            [
                                                19.531,
                                                0
                                            ],
                                            [
                                                19.531,
                                                -34.57
                                            ],
                                            [
                                                30.029,
                                                -39.99
                                            ],
                                            [
                                                35.107,
                                                -39.6
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "r",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "r",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": "v",
            "size": 75,
            "style": "Bold",
            "w": 50.54,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                15.381,
                                                -52.832
                                            ],
                                            [
                                                0.635,
                                                -52.832
                                            ],
                                            [
                                                18.457,
                                                0
                                            ],
                                            [
                                                31.934,
                                                0
                                            ],
                                            [
                                                49.756,
                                                -52.832
                                            ],
                                            [
                                                35.01,
                                                -52.832
                                            ],
                                            [
                                                25.195,
                                                -17.236
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "v",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "v",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": "i",
            "size": 75,
            "style": "Bold",
            "w": 26.51,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                20.312,
                                                -52.832
                                            ],
                                            [
                                                6.152,
                                                -52.832
                                            ],
                                            [
                                                6.152,
                                                0
                                            ],
                                            [
                                                20.312,
                                                0
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "i",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            },
                            {
                                "ind": 1,
                                "ty": "sh",
                                "ix": 2,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                -1.449,
                                                -1.367
                                            ],
                                            [
                                                -2.377,
                                                0
                                            ],
                                            [
                                                -1.449,
                                                1.367
                                            ],
                                            [
                                                0,
                                                2.148
                                            ],
                                            [
                                                1.432,
                                                1.367
                                            ],
                                            [
                                                2.409,
                                                0
                                            ],
                                            [
                                                1.416,
                                                -1.367
                                            ],
                                            [
                                                0,
                                                -2.116
                                            ]
                                        ],
                                        "o": [
                                            [
                                                1.448,
                                                1.367
                                            ],
                                            [
                                                2.376,
                                                0
                                            ],
                                            [
                                                1.448,
                                                -1.367
                                            ],
                                            [
                                                0,
                                                -2.116
                                            ],
                                            [
                                                -1.433,
                                                -1.367
                                            ],
                                            [
                                                -2.441,
                                                0
                                            ],
                                            [
                                                -1.416,
                                                1.367
                                            ],
                                            [
                                                0,
                                                2.148
                                            ]
                                        ],
                                        "v": [
                                            [
                                                7.495,
                                                -61.23
                                            ],
                                            [
                                                13.232,
                                                -59.18
                                            ],
                                            [
                                                18.97,
                                                -61.23
                                            ],
                                            [
                                                21.143,
                                                -66.504
                                            ],
                                            [
                                                18.994,
                                                -71.729
                                            ],
                                            [
                                                13.232,
                                                -73.779
                                            ],
                                            [
                                                7.446,
                                                -71.729
                                            ],
                                            [
                                                5.322,
                                                -66.504
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "i",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "i",
                        "np": 5,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": "c",
            "size": 75,
            "style": "Bold",
            "w": 52.15,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                1.66,
                                                2.38
                                            ],
                                            [
                                                0,
                                                5.445
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.677,
                                                2.396
                                            ],
                                            [
                                                -3.288,
                                                0
                                            ],
                                            [
                                                -1.628,
                                                -1.718
                                            ],
                                            [
                                                -0.066,
                                                -2.748
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                3.987,
                                                3.76
                                            ],
                                            [
                                                6.608,
                                                0
                                            ],
                                            [
                                                4.329,
                                                -4.85
                                            ],
                                            [
                                                0,
                                                -8.138
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -4.362,
                                                -4.801
                                            ],
                                            [
                                                -7.552,
                                                0
                                            ],
                                            [
                                                -3.337,
                                                1.643
                                            ],
                                            [
                                                -1.921,
                                                2.979
                                            ],
                                            [
                                                -0.033,
                                                3.581
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                1.627,
                                                -1.432
                                            ],
                                            [
                                                2.604,
                                                0
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.66,
                                                -2.38
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -5.379
                                            ],
                                            [
                                                1.676,
                                                -2.396
                                            ],
                                            [
                                                2.669,
                                                0
                                            ],
                                            [
                                                1.627,
                                                1.718
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.066,
                                                -6.25
                                            ],
                                            [
                                                -3.988,
                                                -3.76
                                            ],
                                            [
                                                -7.552,
                                                0
                                            ],
                                            [
                                                -4.33,
                                                4.851
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                8.464
                                            ],
                                            [
                                                4.362,
                                                4.802
                                            ],
                                            [
                                                4.036,
                                                0
                                            ],
                                            [
                                                3.336,
                                                -1.643
                                            ],
                                            [
                                                1.92,
                                                -2.979
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -0.066,
                                                2.377
                                            ],
                                            [
                                                -1.628,
                                                1.433
                                            ],
                                            [
                                                -3.386,
                                                0
                                            ]
                                        ],
                                        "v": [
                                            [
                                                19.824,
                                                -13.97
                                            ],
                                            [
                                                17.334,
                                                -25.707
                                            ],
                                            [
                                                17.334,
                                                -27.174
                                            ],
                                            [
                                                19.849,
                                                -38.837
                                            ],
                                            [
                                                27.295,
                                                -42.432
                                            ],
                                            [
                                                33.74,
                                                -39.854
                                            ],
                                            [
                                                36.279,
                                                -33.154
                                            ],
                                            [
                                                49.512,
                                                -33.154
                                            ],
                                            [
                                                43.433,
                                                -48.169
                                            ],
                                            [
                                                27.539,
                                                -53.809
                                            ],
                                            [
                                                9.717,
                                                -46.533
                                            ],
                                            [
                                                3.223,
                                                -27.051
                                            ],
                                            [
                                                3.223,
                                                -26.123
                                            ],
                                            [
                                                9.766,
                                                -6.226
                                            ],
                                            [
                                                27.637,
                                                0.977
                                            ],
                                            [
                                                38.696,
                                                -1.489
                                            ],
                                            [
                                                46.582,
                                                -8.423
                                            ],
                                            [
                                                49.512,
                                                -18.262
                                            ],
                                            [
                                                36.279,
                                                -18.262
                                            ],
                                            [
                                                33.74,
                                                -12.549
                                            ],
                                            [
                                                27.393,
                                                -10.4
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "c",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "c",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        },
        {
            "ch": "s",
            "size": 75,
            "style": "Bold",
            "w": 51.42,
            "data": {
                "shapes": [
                    {
                        "ty": "gr",
                        "it": [
                            {
                                "ind": 0,
                                "ty": "sh",
                                "ix": 1,
                                "ks": {
                                    "a": 0,
                                    "k": {
                                        "i": [
                                            [
                                                1.383,
                                                -1.025
                                            ],
                                            [
                                                2.702,
                                                0
                                            ],
                                            [
                                                1.725,
                                                1.335
                                            ],
                                            [
                                                0.13,
                                                2.507
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                -1.953,
                                                -2.75
                                            ],
                                            [
                                                -3.435,
                                                -1.579
                                            ],
                                            [
                                                -4.427,
                                                0
                                            ],
                                            [
                                                -4.134,
                                                2.979
                                            ],
                                            [
                                                0,
                                                4.818
                                            ],
                                            [
                                                7.454,
                                                2.734
                                            ],
                                            [
                                                3.516,
                                                0.7
                                            ],
                                            [
                                                1.481,
                                                0.961
                                            ],
                                            [
                                                0,
                                                1.562
                                            ],
                                            [
                                                -1.302,
                                                1.074
                                            ],
                                            [
                                                -2.377,
                                                0
                                            ],
                                            [
                                                -1.302,
                                                -1.318
                                            ],
                                            [
                                                0,
                                                -2.018
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                4.02,
                                                3.158
                                            ],
                                            [
                                                6.705,
                                                0
                                            ],
                                            [
                                                3.889,
                                                -3.141
                                            ],
                                            [
                                                0,
                                                -4.688
                                            ],
                                            [
                                                -12.566,
                                                -2.637
                                            ],
                                            [
                                                -1.709,
                                                -0.993
                                            ],
                                            [
                                                0,
                                                -1.725
                                            ]
                                        ],
                                        "o": [
                                            [
                                                -1.384,
                                                1.025
                                            ],
                                            [
                                                -2.898,
                                                0
                                            ],
                                            [
                                                -1.726,
                                                -1.334
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                3.191
                                            ],
                                            [
                                                1.953,
                                                2.751
                                            ],
                                            [
                                                3.434,
                                                1.579
                                            ],
                                            [
                                                6.543,
                                                0
                                            ],
                                            [
                                                4.134,
                                                -2.979
                                            ],
                                            [
                                                0,
                                                -6.738
                                            ],
                                            [
                                                -2.409,
                                                -0.879
                                            ],
                                            [
                                                -3.516,
                                                -0.7
                                            ],
                                            [
                                                -1.482,
                                                -0.96
                                            ],
                                            [
                                                0,
                                                -1.66
                                            ],
                                            [
                                                1.302,
                                                -1.074
                                            ],
                                            [
                                                2.766,
                                                0
                                            ],
                                            [
                                                1.302,
                                                1.318
                                            ],
                                            [
                                                0,
                                                0
                                            ],
                                            [
                                                0,
                                                -5.045
                                            ],
                                            [
                                                -4.021,
                                                -3.157
                                            ],
                                            [
                                                -6.283,
                                                0
                                            ],
                                            [
                                                -3.89,
                                                3.142
                                            ],
                                            [
                                                0,
                                                8.041
                                            ],
                                            [
                                                3.776,
                                                0.781
                                            ],
                                            [
                                                1.709,
                                                0.993
                                            ],
                                            [
                                                0,
                                                1.66
                                            ]
                                        ],
                                        "v": [
                                            [
                                                31.958,
                                                -10.571
                                            ],
                                            [
                                                25.83,
                                                -9.033
                                            ],
                                            [
                                                18.896,
                                                -11.035
                                            ],
                                            [
                                                16.113,
                                                -16.797
                                            ],
                                            [
                                                2.734,
                                                -16.797
                                            ],
                                            [
                                                5.664,
                                                -7.886
                                            ],
                                            [
                                                13.745,
                                                -1.392
                                            ],
                                            [
                                                25.537,
                                                0.977
                                            ],
                                            [
                                                41.553,
                                                -3.491
                                            ],
                                            [
                                                47.754,
                                                -15.186
                                            ],
                                            [
                                                36.572,
                                                -29.395
                                            ],
                                            [
                                                27.686,
                                                -31.763
                                            ],
                                            [
                                                20.19,
                                                -34.253
                                            ],
                                            [
                                                17.969,
                                                -38.037
                                            ],
                                            [
                                                19.922,
                                                -42.139
                                            ],
                                            [
                                                25.439,
                                                -43.75
                                            ],
                                            [
                                                31.543,
                                                -41.772
                                            ],
                                            [
                                                33.496,
                                                -36.768
                                            ],
                                            [
                                                47.607,
                                                -36.768
                                            ],
                                            [
                                                41.577,
                                                -49.072
                                            ],
                                            [
                                                25.488,
                                                -53.809
                                            ],
                                            [
                                                10.229,
                                                -49.097
                                            ],
                                            [
                                                4.395,
                                                -37.354
                                            ],
                                            [
                                                23.242,
                                                -21.338
                                            ],
                                            [
                                                31.47,
                                                -18.677
                                            ],
                                            [
                                                34.033,
                                                -14.6
                                            ]
                                        ],
                                        "c": true
                                    },
                                    "ix": 2
                                },
                                "nm": "s",
                                "mn": "ADBE Vector Shape - Group",
                                "hd": false
                            }
                        ],
                        "nm": "s",
                        "np": 3,
                        "cix": 2,
                        "bm": 0,
                        "ix": 1,
                        "mn": "ADBE Vector Group",
                        "hd": false
                    }
                ]
            },
            "fFamily": "Roboto"
        }
    ]
}